module.exports = __webpack_public_path__ + "img/teasers_2.d02681e9.jpg";